<template>
    <div class="max-w-[1120px] mx-auto rounded-lg overflow-x-auto shadow-lg">
        <div
            class="grid grid-cols-3 bg-gray-300 text-[16px] sm:text-[20px] md:text-[20px] font-ExpandedBold border-b border-gray-400 p-3 text-center">
            <div class="justify-center whitespace-nowrap">Selected Player</div>
            <div class="justify-center whitespace-nowrap">Team</div>
            <div class="justify-center whitespace-nowrap min-w-[70px]">Goals Scored</div>
        </div>
        <div v-for="(entry, index) in leaderboard[0].bet_details.players" :key="index" :class="[
            'grid grid-cols-3 text-center items-center p-3 font-ExpandedBold text-[15px] sm:text-[18px] md:text-[18px] border-b border-gray-200'
        ]">
            <div>{{ entry.name }}</div>
            <div>{{ entry.team.name }}</div>
            <div>{{ entry.total_goals }}</div>
        </div>
    </div>
</template>

<script setup>
// import { defineProps } from 'vue';

const props = defineProps({
    leaderboard: {
        type: Array,
        required: true
    },
    FinalResultData: {
        type: Object,
        required: true
    }
});

const { leaderboard, FinalResultData } = props
console.log("🚀 ~ leaderboard:", leaderboard);


</script>